"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconFont = void 0;
var honeycomb_1 = require("@honeycomb-npm/honeycomb");
var PropTypes = require("prop-types");
var React = require("react");
var IconFont = function (props) {
    if (typeof honeycomb_1.Icons.IconList[props.symbol] === 'undefined') {
        return null;
    }
    if (typeof honeycomb_1.Icons.IconList[props.symbol].iconfont === 'undefined') {
        return null;
    }
    var className = "hc-icon " + honeycomb_1.Icons.IconList[props.symbol].iconfont;
    if (props.className) {
        className += " " + props.className;
    }
    return (React.createElement("i", { className: className, "aria-hidden": "true" }));
};
exports.IconFont = IconFont;
exports.IconFont.propTypes = {
    className: PropTypes.string,
    symbol: PropTypes.oneOf(Object.keys(honeycomb_1.Icons.IconList).filter(function (iconname) {
        if (typeof honeycomb_1.Icons.IconList[iconname].iconfont === 'undefined') {
            return false;
        }
        return true;
    })).isRequired,
};
